module.exports = __webpack_public_path__ + "img/mbanner_headphone.cb5eedf6.png";